import { createTheme } from '@mui/material/styles'
import { PaletteOptions } from '@mui/material/styles/createPalette'

const palette: PaletteOptions = {
  divider: '#F2F6FA',
  primary: {
    main: '#1063CD',
  },
  custom: {
    white: '#FFFFFF',
    blue1: '#051350',
    blue2: '#1063CD',
    blue3: '#387CD5',
    gray1: '#8389A7',
    gray2: '#757D9F',
    gray3: '#F6F7FC',
    gray4: '#F2F6FA',
    gray5: '#3A405F',
    gray6: '#E6EFF8',
    gray7: '#C2C5C8',
    gray8: '#D6DFF7',
    gray9: '#D1D9F0',
    gray10: '#D2D8EF',
    gray11: '#4E515D',
    gray12: '#DDE1E8',
    gray13: '#EFF0f4',
    gray14: '#4C5783',
    gray15: '#8B95A5',
    gray16: '#222F3E',
    gray17: '#97A2C8',
    orange1: '#E4922E',
    orange2: '#E4922F',
    green1: '#3ABF77',
    red1: '#EA4968',
  },
}

const theme = createTheme({
  spacing: 8,
  palette,
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '4px',
          height: '40px',
          boxShadow: 'none',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
          backgroundColor: palette.custom.gray3,
        },
      },
    },
    MuiAvatar: {
      styleOverrides: {
        root: {
          width: 32,
          height: 32,
          fontSize: '13px',
          fontWeight: 500,
          lineHeight: '32px',
          backgroundColor: palette.custom.orange1,
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          lineHeight: 1,
        },
      },
    },
    MuiBreadcrumbs: {
      styleOverrides: {
        root: {
          color: palette.custom.blue1,
        },
        separator: {
          marginLeft: '0px',
          marginRight: '4px',
        },
      },
    },
    MuiTooltip: {
      defaultProps: {
        enterDelay: 500,
        enterNextDelay: 500,
      },
      styleOverrides: {
        tooltip: {
          borderRadius: '6px',
          backgroundColor: palette.custom.gray16,
          color: palette.custom.gray8,
          fontSize: '14px',
          padding: '12px 14px',
          fontWeight: '400',
          marginTop: '7px !important',
          maxWidth: '210px',
        },
      },
    },
  },
})

export { theme }
